
import { Dictionary } from "../common/shared.model";

/* User defined models */
export class Candidate {
    Id: string;
    Href?: string;
    CandidateId: number;
    CandidateUuid?: any;
    PrometricId?: string;
    Suffix?: string;
    FirstName: string;
    MiddleName?: string;
    LastName?: string;
    EmailAddress?: string;
    NewEmailAddress?: string;
    AddressLine1?: string;
    AddressLine2?: string;
    AddressLine3?: string;
    AddressLine4?: string;
    City?: string;
    StateProvince?: string;
    PostalCode?: string;
    Country?: string;
    PrimaryPhoneNumber?: string;
    PrimaryPhoneExtension?: string;
    SecondaryPhoneNumber?: string;
    SecondaryPhoneExtension?: string;
    FaxNumber?: string;
    BirthDate?: any;
    DemographicTemplateName?: string;
    ProfileUniqueId?: any;
    RequiresValidation?: string;
    ClientCode?: string;
    ProgramCode?: string;
    ExamCode?: string;
    UserAccountEmail?: string;
    CreateLogin?: string;
    Username?: string;
    SubscribeToEmails?: Boolean;
    WorkPhoneNumber?: string;
    PhoneExtension?: string;
    Values: any;
    isAllRequiredValuesExist?: boolean;
    clientCode?: string;
    programCode?: string;
    examCode?: string;

    details: Dictionary; //candidateDetails
    // Added a new property to set default values as the no of keys may different from eligibility & demographics.
    defaultDetails: Dictionary;//candidateDefaultDetails

    // use to mentain the state when user is going back (TODO: Remove it)
    defaultInitialDetails: Dictionary;//candidateDefaultOldData

    // Used to add demographics from Default Initial Details to Details during registration without duplicating values from demographics template
    demographicTemplateKeys: Dictionary;
}